import {
  DESLogServerLoggerClientOptions,
} from '@des/services/logging';

/**
 * DEFAULT server logger client options for Booking
 */
export const BOOKING_SERVER_LOGGER_CLIENT_OPTIONS: Partial<DESLogServerLoggerClientOptions> = {
  appName: 'RefX-Booking'
};
